export default __webpack_public_path__ + "media/src/assets/images/logo-396319e5c80ab885bd464de1ceb05b31.png";